import * as S from './styles';
import PhotoBenef from '../../../assets/image/beneficiaryPhoto.svg';
import CompTextField from 'components/CompTextField';
import CompDateField from '../../CompDateField';
import { NisField } from 'components/NisField';
import { Grid } from '@mui/material';

const Forms = ({
  beneficiaryData,
  isView,
  isEdit,
  register,
  unregister,
  watch,
  setValue,
  errors,
}) => {
  const nis = watch('twin_child_nis');

  const handleNis = (data) => {
    setValue('twin_child_name', data.name);
    setValue('twin_child_cpf', data.cpf);
    setValue('twin_child_birth', data.birth);
  };

  return (
    <S.Form>
      <S.FormGeral>
        <S.PhotoContainer src={PhotoBenef} alt="Logo" />

        <Grid container spacing={3}>
          {/* Linha 1 */}
          <Grid item xs={12} md={6}>
            <NisField
              nis={nis}
              textLabel="NIS DA CRIANÇA:"
              isView={isView}
              isEdit={isEdit}
              apiText={beneficiaryData?.twin_child_nis}
              benefitNis={beneficiaryData?.twin_child_nis}
              name="twin_child_nis"
              register={register}
              unregister={unregister}
              error={errors.twin_child_nis}
              helperText={errors.twin_child_nis && errors.twin_child_nis.message}
              handleNis={handleNis}
              setValue={setValue}
              b_status={beneficiaryData?.b_status}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CompTextField
              textLabel="NOME COMPLETO DA CRIANÇA:"
              isView={isView}
              fromNis={true}
              apiText={beneficiaryData?.twin_child_name}
              placeholder="00000000000"
              required
              name="twin_child_name"
              register={register}
              unregister={unregister}
              error={errors.twin_child_name}
              helperText={errors.twin_child_name && errors.twin_child_name.message}
            />
          </Grid>

          {/* Linha 2 */}
          <Grid item xs={12} md={6}>
            <CompTextField
              textLabel="CPF DA CRIANÇA:"
              isView={isView}
              fromNis={true}
              apiText={beneficiaryData?.twin_child_cpf}
              placeholder="xxx.xxx.xxx-xx"
              required
              name="twin_child_cpf"
              register={register}
              unregister={unregister}
              error={errors.twin_child_cpf}
              helperText={errors.twin_child_cpf && errors.twin_child_cpf.message}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CompDateField
              isView={isView}
              labelText="DATA DE NASCIMENTO:"
              apiText={beneficiaryData?.twin_child_birth}
              required
              name="twin_child_birth"
              register={register}
              unregister={unregister}
              error={errors.twin_child_birth}
              helperText={errors.twin_child_birth && errors.twin_child_birth.message}
              disabled={!isEdit && !isView}
            />
          </Grid>

          {/* Linha 3 */}
          <Grid item xs={12}>
            <CompTextField
              textLabel="CNS DA CRIANÇA:"
              type="number"
              isView={isView}
              apiText={beneficiaryData?.twin_child_cns}
              edit={isEdit}
              placeholder="00000000000"
              required
              name="twin_child_cns"
              register={register}
              unregister={unregister}
              error={errors.twin_child_cns}
              helperText={errors.twin_child_cns && errors.twin_child_cns.message}
            />
          </Grid>
        </Grid>
      </S.FormGeral>
    </S.Form>
  );
};

export default Forms;
